export default __webpack_public_path__ + "2efb726f0fb37b2d95940177cd4acfcf.svg";